<div class="flex flex-col h-auto gap-4 side-padding sm:px-0">
  <div
    class="flex flex-col w-full gap-3 p-5 pb-0 bg-white max-sm:p-3 max-sm:pb-0 rounded-10"
  >
    @if (matchSummaryService.isLoadingMatchSummary()) {
    <app-skeleton-preview-details />
    } @if(!matchSummaryService.isLoadingMatchSummary() &&
    this.liveMatchSummary()){
    <div>
      <app-football-breadcrumbs [data]="this.liveMatchSummary()!.Competition" />
      <app-match-details [data]="this.liveMatchSummary()!" />
    </div>
    <app-match-header-tab-bar (valueTap)="handleHeaderTap($event)" />
    }

    <!-- Case Error -->
    @if((matchSummaryService.isErrorMatchSummary() &&
    !matchSummaryService.isLoadingMatchSummary()) ){
    <app-no-result message="NotAvalaibleInformation" />
    }
  </div>

  @if(!matchSummaryService.isErrorMatchSummary()&&
  !matchSummaryService.isLoadingMatchSummary() &&
  matchSummaryService.matchSummary()) {
  <div class="w-full h-auto p-5 bg-white max-sm:pt-2 rounded-10">
    @switch (selectedHeaderTab()) { @case (0) {
    <app-match
      [competition]="liveMatchSummary()?.Competition!"
      [tsExternalMatchId]="liveMatchSummary()?.TsExternalId!"
      [gamePeriod]="getGamePeriod()"
    />
    } @case (1) {
    <app-h2h-new [tsExternalMatchId]="liveMatchSummary()?.TsExternalId!" />
    } @case (2) {
    <app-standing
      [tsExternalCompetitionId]="liveMatchSummary()?.Competition?.TsExternalId!"
      [matchId]="liveMatchSummary()?.Id!"
      [homeId]="liveMatchSummary()?.HomeTeam?.Id!"
      [awayId]="liveMatchSummary()?.AwayTeam?.Id!"
    />
    } @default {
    <div>por defecto</div>
    } }
  </div>
  }
</div>
